import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const AiAnalyticsSummaryPageType = z.enum([
  "intent",
  "checkout-overview",
  "widgets",
  "post-purchase",
  "shipping-ai",
]);
export type AiAnalyticsSummaryPageType = z.infer<
  typeof AiAnalyticsSummaryPageType
>;

const MetricDataItem_ = z.object({
  label: z.string(),
  value: z.union([z.string(), z.number()]),
  change: z.number().optional(),
  changeLabel: z.string().optional(),
});
export const MetricDataItem: z.ZodType<MetricDataItem> = MetricDataItem_;
export interface MetricDataItem extends z.infer<typeof MetricDataItem_> {}

const ChartDataItem_ = z.object({
  title: z.string(),
  labels: z.array(z.string()),
  values: z.array(z.number()),
});
export const ChartDataItem: z.ZodType<ChartDataItem> = ChartDataItem_;
export interface ChartDataItem extends z.infer<typeof ChartDataItem_> {}

const AbTestDataItem_ = z.object({
  name: z.string(),
  dateRange: z.string().optional(),
  controlValue: z.union([z.string(), z.number()]),
  treatmentValue: z.union([z.string(), z.number()]),
  lift: z.number(),
  confidence: z.number().optional(),
});
export const AbTestDataItem: z.ZodType<AbTestDataItem> = AbTestDataItem_;
export interface AbTestDataItem extends z.infer<typeof AbTestDataItem_> {}

const AnalyticsData_ = z.object({
  metrics: z.array(MetricDataItem).optional(),
  charts: z.array(ChartDataItem).optional(),
  abTests: z.array(AbTestDataItem).optional(),
});
export const AnalyticsData: z.ZodType<AnalyticsData> = AnalyticsData_;
export interface AnalyticsData extends z.infer<typeof AnalyticsData_> {}

const AiAnalyticsSummarySchema_ = z.object({
  _id: zExt.objectId(),
  team: zExt.objectId(),
  pageType: AiAnalyticsSummaryPageType,
  summary: z.string(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export const AiAnalyticsSummarySchema: z.ZodType<AiAnalyticsSummary> =
  AiAnalyticsSummarySchema_;
export interface AiAnalyticsSummary
  extends z.infer<typeof AiAnalyticsSummarySchema_> {}
export type CreateAiAnalyticsSummary = Omit<
  AiAnalyticsSummary,
  "_id" | "createdAt" | "updatedAt"
>;
